<script>
  import {
    Card,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Button,
  } from 'sveltestrap'
  import { onMount } from 'svelte'

  let data = ''
  let dataPage = ''
  async function getData() {
    let location = 'es-CL'
    location = await localStorage.getItem('LANGUAGE')
    if (location == 'es') {
      location = 'es-CL'
    }
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }
    console.log(
      'location: ',
      `https://api.rastros.cl/api/home-screen?populate=*&locale=${location}`
    )
    fetch(
      `https://api.rastros.cl/api/home-screen?populate=*&locale=${location}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        dataPage = result.data
      })
      .catch((error) => console.log('error al contactar al servicio: ', error))
  }
  onMount(async () => {
    await getData()
    let user = localStorage.getItem('authUser')
    if (!user) {
      throw redirect('/login')
    }
    user = JSON.parse(user)
    var headers = new Headers()
    //TODO: actualizar authorization para recibir el de sesión
    headers.append('Authorization', 'Bearer ' + user.jwt)
    var requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    }
    fetch(
      'https://api.rastros.cl/api/new-in-messages?populate[0]=new_device&sort[0]=id:desc&pagination%5Blimit%5D=10&populate[1]=new_device.new_tank&populate[2]=new_device.new_tank.new_truck',
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        data = result.data
      })
      .catch((error) => console.log('error al contactar al servicio: ', error))
  })

  let modal = false

  const togglemodal = () => (modal = !modal)
</script>

<!--Latest Transaction-->
<Card>
  <CardBody>
    <div class="mb-4 h4 card-title">{dataPage.tripRegisterLabel}</div>
    <div class="table-responsive">
      <table class="table align-middle table-nowrap mb-0">
        <thead class="table-light">
          <tr>
            <th style="width: 20px;">
              <div class="form-check font-size-16 align-middle">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="transactionCheck01"
                />
                <label class="form-check-label" for="transactionCheck01"
                ></label>
              </div>
            </th>
            <th class="align-middle">Status</th>
            <th class="align-middle">{dataPage.dateLabel}</th>
            <th class="align-middle">{dataPage.hourLabel}</th>
            <th class="align-middle">{dataPage.deviceIDLabel}</th>
            <th class="align-middle">{dataPage.patentTruckLabel}</th>
            <th class="align-middle">Payload</th>
            <th class="align-middle">{dataPage.patentTankLabel}</th>
            <th class="align-middle">{dataPage.latitudeLabel}</th>
            <th class="align-middle">{dataPage.longitudeLabel}</th>
            <th class="align-middle">{dataPage.alertStateTitle}</th>
          </tr>
        </thead>
        <tbody>
          {#each data as dato}
            <tr>
              <td>
                <div class="form-check font-size-16">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="transactionCheck02"
                  />
                  <label class="form-check-label" for="transactionCheck02"
                  ></label>
                </div>
              </td>
              <td>
                {#if dato.Message_type === 'AL'}
                  <i class="mdi mdi-car-brake-alert green font-size-24"></i>
                {:else if dato.Message_type === 'RR'}
                  <i class="icon-chat"></i>
                {:else if dato.Message_type === 'SM'}
                  <i class="mdi mdi-alert-rhombus orange font-size-24"></i>
                {:else if dato.Message_type === 'S1'}
                  <i class="mdi mdi-check-decagram green font-size-24"></i>
                {/if}
              </td>

              <td>
                <!--//TODO:Cambiar formato de fecha y hora-->
                {dato.publishedAt
                  ? new Date(dato.publishedAt).toLocaleDateString()
                  : ''}
              </td>
              <td>
                {dato.publishedAt
                  ? new Date(dato.publishedAt).toLocaleTimeString()
                  : ''}
              </td>
              <td>
                {dato.Message_id}
              </td>
              <td>
                {dato.new_device.new_tank.new_truck.Patent}
              </td>
              <td>
                {dato.Payload}
              </td>
              <td>
                {dato.new_device.new_tank.Patent_truck}
              </td>

              <td>
                {dato.Latitude}
              </td>
              <td>
                {dato.Longitude}
              </td>
              <td>
                {dato.Payload.substring(7, 13) === '000000'
                  ? 'CERRADO'
                  : 'ABIERTO'}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </CardBody>
</Card>

<Modal
  isOpen={modal}
  role="dialog"
  autoFocus={true}
  data-toggle="modal"
  centered
  on:click={togglemodal}
>
  <div class="modal-content border-bottom-0">
    <div class="modal-header">
      <h5 class="modal-title">Detalle del viaje</h5>
      <button
        type="button"
        class="btn-close"
        on:click={togglemodal}
        data-bs-dismiss="modal"
        aria-label="Close"
      />
    </div>

    <ModalBody>
      <p class="mb-2">
        Orden ID: <span class="text-primary">#0-0001</span>
      </p>
      <p class="mb-4">
        Punto inicio:{' '}
        <span class="text-primary">Santiago 234</span>
        <span class="text-primary">Melipilla 124</span>
      </p>

      <div class="table-responsive">
        <Table class="table align-middle table-nowrap">
          <thead>
            <tr>
              <th scope="col">Patente</th>
              <th scope="col">Puntos de destino</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">
                <div>
                  <h5 class="text-truncate font-size-14">FA7342</h5>
                </div>
              </th>
              <td>
                <div>
                  <h3 class="text-truncate font-size-14">
                    Inicio:Santiago 234
                  </h3>
                  <p class="text-muted mb-0">Punto 1: Providencia</p>
                  <p class="text-muted mb-0">Punto 2: Macul</p>
                  <p class="text-muted mb-0">Punto 3: Quinta normal</p>
                  <h3 class="text-truncate font-size-14">
                    Termino:Santiago 234
                  </h3>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-right">Estados de los puntos:</h6>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-right">Punto 1</h6>
              </td>
              <td>
                <select class="form-control select2" title="Country">
                  <option value="0">Seleccionar estado</option>
                  <option value="AF">Pendiente</option>
                  <option value="AF">Activo</option>
                  <option value="AF">Inactivo</option>
                  <option value="AF">Cancelado</option>
                </select>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-right">Punto 2</h6>
              </td>
              <td>
                <select class="form-control select2" title="Country">
                  <option value="0">Seleccionar estado</option>
                  <option value="AF">Pendiente</option>
                  <option value="AF">Activo</option>
                  <option value="AF">Inactivo</option>
                  <option value="AF">Cancelado</option>
                </select>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-right">Punto 3</h6>
              </td>
              <td>
                <select class="form-control select2" title="Country">
                  <option value="0">Seleccionar estado</option>
                  <option value="AF">Pendiente</option>
                  <option value="AF">Activo</option>
                  <option value="AF">Inactivo</option>
                  <option value="AF">Cancelado</option>
                </select>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button type="button" color="secondary" on:click={togglemodal}>
        Guardar
      </Button>
    </ModalFooter>
  </div>
</Modal>

<style>
  .green {
    color: #00cc82;
  }
  .orange {
    color: #ff9900;
  }
</style>
